'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { useAuth } from '@/contexts/AuthContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function LoginPage() {
  const { login, user } = useAuth();
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) {
      router.replace('/');
    }
  }, [user, router]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login({ email, password });
      router.replace('/');
    } catch (err: any) {
      setError(err?.message ?? 'ログインに失敗しました');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className='min-h-screen bg-white'>
      <Header />
      <main className='bg-washi'>
        <section className='mx-auto max-w-7xl px-6 py-16'>
          <div className='mx-auto max-w-md border border-gray-100 bg-white p-6 shadow-sm'>
            <h1 className='text-center font-serif text-2xl text-gray-800'>
              ログイン
            </h1>
            <form className='mt-6 space-y-4' onSubmit={onSubmit}>
              <div>
                <label
                  htmlFor='login-email'
                  className='block text-sm font-semibold text-gray-800'
                >
                  メールアドレス
                </label>
                <input
                  id='login-email'
                  className='mt-2 w-full border border-gray-200 px-3 py-3 text-[15px]'
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <div>
                <label
                  htmlFor='login-password'
                  className='block text-sm font-semibold text-gray-800'
                >
                  パスワード
                </label>
                <input
                  id='login-password'
                  className='mt-2 w-full border border-gray-200 px-3 py-3 text-[15px]'
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                />
                <p className='mt-1 text-right'>
                  <Link
                    href='/forgot-password'
                    className='text-sm text-gray-600 hover:text-primary hover:underline'
                  >
                    パスワードをお忘れですか
                  </Link>
                </p>
              </div>
              {error && <p className='text-sm text-rose-600'>{error}</p>}
              <button
                type='submit'
                disabled={submitting}
                className='mt-2 inline-flex w-full items-center justify-center bg-primary px-4 py-3 text-sm font-semibold text-white disabled:opacity-60'
              >
                {submitting ? '送信中…' : 'ログイン'}
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
